import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function NotFound() {
    return (
        <>
            <Nav />
            <main
                data-testid="not-found-page"
                className="min-h-[80vh] flex items-center bg-charcoal"
            >
                <div className="empire-container text-center max-w-2xl mx-auto py-32">
                    <p className="empire-eyebrow">404 · Not Found</p>
                    <h1 className="mt-6 font-serif text-cream text-[5rem] md:text-[8rem] leading-none">
                        404<span className="text-gold">.</span>
                    </h1>
                    <p className="empire-body mt-6">
                        This page has wandered off the menu. Let&rsquo;s get you back home.
                    </p>
                    <Link
                        to="/"
                        data-testid="404-home"
                        className="empire-btn-primary mt-10"
                    >
                        Return Home
                    </Link>
                </div>
            </main>
            <Footer />
        </>
    );
}
